<template>
  <div>
    <AddGiftCode @updatePage="getList" />

    <!-- List Table -->
    <!-- <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      :moduleName="`giftcode.giftcodes`"
      :moduleSearch="search"
    >
      <template v-slot:item.gift_mode="{ item }">
        {{
          item.gift_value +
          ' ' +
          (item.gift_mode == 'percentage' ? '%' : item.gift_mode)
        }}
      </template>

      <template v-slot:item.action="{ item }">
        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>
    </List>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" /> -->
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'GiftCodes',
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      header: [
        { text: 'giftcode.code', value: 'code' },
        { text: 'giftcode.discount', value: 'gift_mode' },
        { text: this.$t('global.actions'), value: 'action', size: '100px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'giftcode.giftcodes',
        route: '/gift-codes',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'giftcode.giftcodes',
        },
      ],
      // searchPlaceholder: 'servers.searchForTemplate',
      showDetailButton: false,
    })

    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.getList()
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `core/gift-codes?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&giftCode=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `blabla/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    AddGiftCode: () => import('@/components/forms/AddGiftCode'),
  },
}
</script>
